export default __webpack_public_path__ + "static/media/radio-selected-tick-light.85da8b70.svg";